/**
 * RouteSeo
 *
 * Sits inside the router. On every route (and language) change it sets the
 * page title, description, canonical and social tags from src/lib/seo.ts, so a
 * public page reaches Google with its own title, and every other route says
 * noindex. Renders nothing.
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLang } from '../contexts/LangContext'
import { seoPageFor, canonicalUrl, setMetaTag, setCanonical } from '../lib/seo'

const BRAND = 'Immigrant Shield for Offices'

export function RouteSeo() {
  const { pathname } = useLocation()
  const { t } = useLang()

  useEffect(() => {
    const page = seoPageFor(pathname)
    if (!page) {
      document.title = BRAND
      setMetaTag('name', 'robots', 'noindex')
      setCanonical(null)
      return
    }
    const title = t(`seo.${page}.title`)
    const description = t(`seo.${page}.description`)
    const url = canonicalUrl(pathname)
    document.title = title
    setMetaTag('name', 'robots', null)
    setMetaTag('name', 'description', description)
    setCanonical(url)
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:url', url)
    setMetaTag('name', 'twitter:title', title)
    setMetaTag('name', 'twitter:description', description)
  }, [pathname, t])

  return null
}
